import { render, staticRenderFns } from "./jsaTargetJobRisk.vue?vue&type=template&id=1f0f8c8d"
import script from "./jsaTargetJobRisk.vue?vue&type=script&lang=js"
export * from "./jsaTargetJobRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0f8c8d')) {
      api.createRecord('1f0f8c8d', component.options)
    } else {
      api.reload('1f0f8c8d', component.options)
    }
    module.hot.accept("./jsaTargetJobRisk.vue?vue&type=template&id=1f0f8c8d", function () {
      api.rerender('1f0f8c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/plan/jsaTargetJobRisk.vue"
export default component.exports